module.exports = __webpack_public_path__ + "static/media/mg1.54089de3.png";